import { ContentBlock } from '@components/ContentBlock/ContentBlock';
import { WindowContentLayout } from '@layouts/WindowContentLayout/WindowContentLayout';
import React from 'react';
import { Avatar, GroupBox } from 'react95';
import './AboutMe.scss';
import ImagePhoto from './photo.webp';

export const AboutMe = () => {

  return (
    <div className="about-me">
      <WindowContentLayout>
        <GroupBox className="about-me__content-block" label={<div className="flex">
          <Avatar size={40} src={ImagePhoto} style={{marginRight: '0.5rem'}} />
          <h2 className="about-me__content-block__title">Hello! I'm Serhiy.</h2>
        </div>}>
          <p style={{marginTop: '0.5rem'}}>
            I was born in western Ukraine, but grew up in Portugal and now reside in the vibrant city of Dubai. By
            day I'm a software engineer, by night - a motorcycle junkie. With a deep passion for software engineering,
            I've
            worked and lived in five different countries developing numerous digital platforms, web and hybrid mobile
            applications. My tech stack is primarily Web technologies and React Native. I'm also profoundly
            passionate about cloud computing platforms (AWS) and building CI/CD pipelines
            to enhance performance and efficiency of teams.
          </p>
        </GroupBox>
        <br />
        <ContentBlock title={'A Little More About My Journey'}>
          I graduated from Universidade NOVA de Lisboa with a master's degree in Computer Science and Engineering.
          Upon completing my studies, I decided to move to Italy where I secured an internship and began working for a
          fintech product company. Two years later, I transitioned to consultancy and started travelling abroad as per
          project requirements.
          <br />
          <br />
          Travel became a cornerstone of my life. Discovering new cultures and languages inspired me to
          venture further. As a result, I relocated to the Middle East where I continued in consultancy. However,
          within a year, I shifted gears to join a start-up in the fintech/crypto sector. I love fintech and
          opportunities it opens for people to exchange value.
        </ContentBlock>
        {/*<ContentBlock title={`Let's Connect`}>*/}
        {/*  If you want to contact me, please add me on <Anchor href='https://www.linkedin.com/in/moskovchuk'*/}
        {/*                                                      target='_blank'>LinkedIn</Anchor> or <Anchor*/}
        {/*  href='https://github.com/mkmule' target='_blank'>Github</Anchor>.*/}
        {/*</ContentBlock>*/}
        {/*<br />*/}
        {/*<ContentBlock title={`Serhiy's README.md`}>*/}
        {/*  A quick presentation about my professional profile and expectations as Engineering Manager.*/}
        {/*  <br />*/}
        {/*  <br />*/}
        {/*  <iframe*/}
        {/*    title={'README Presentation'}*/}
        {/*    src="https://docs.google.com/presentation/d/13UKPb_Z71MOh5XJTl7xbb7Ppbi9mLBBODa5NyOh1TMA/embed"*/}
        {/*    frameBorder="0" allowFullScreen="true" mozallowfullscreen="true"*/}
        {/*    webkitallowfullscreen="true" />*/}
        {/*</ContentBlock>*/}
      </WindowContentLayout>
    </div>
  );
};
